import { CheckIcon } from "@heroicons/react/outline";

import { NavigationProps } from "./types";

import { OverflowDisplayTooltip } from "@/components/ui/Tooltip/OverflowDisplayTooltip";
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";

export const Navigation = ({
  setOpen,
  currentFolder,
  selectedFolderId,
  entityFolderIds,
  handleMove,
}: NavigationProps) => {
  const isAlreadyInFolder =
    entityFolderIds.length > 0 && entityFolderIds.every(id => id === selectedFolderId);

  const destinationName = !currentFolder ? "Home" : currentFolder?.name;

  return (
    <DialogFooter className="flex !justify-between border-t border-gray-200 px-6 py-4">
      <Button className="text-sm" onClick={() => setOpen(false)} variant="outline">
        Cancel
      </Button>

      <div className="flex gap-2 overflow-hidden">
        <Button
          className="w-auto min-w-[120px] cursor-pointer overflow-hidden text-sm"
          disabled={isAlreadyInFolder}
          onClick={handleMove}
          variant="default"
        >
          <CheckIcon className="mr-2 h-4 w-4 flex-shrink-0" />
          <OverflowDisplayTooltip delayDuration={300} content={`Move to ${destinationName}`}>
            <span className="truncate">Move to {destinationName}</span>
          </OverflowDisplayTooltip>
        </Button>
      </div>
    </DialogFooter>
  );
};
